import { ActionTypeList } from '../../constants'

const initialState = {
    loading: false,
    isSuccess: false,
    successMessage: '',
    toShowMessage: false,
    error: "",
};

const targetInsertStatusPayload = (state = initialState, action) => {
    //console.log(`targetInsertStatusPayload initial state ${JSON.stringify(state)} action type ${action.type} payload ${JSON.stringify(action.payload)}`);

    switch (action.type) {
        case ActionTypeList.TARGET_SETTING_INSERTED:
            return {
                loading: false,
                isSuccess: true,
                successMessage: action.payload,
                toShowMessage: true,
                error: ""
            };
        case ActionTypeList.TARGET_SETTING_INSERT:
            return {
                loading: true,
                isSuccess: false,
                toShowMessage: true,
                error: action.payload.data.error
            };
        case ActionTypeList.TARGET_SETTING_INSERTED_HIDE_MSG:
            return {
                loading: false,
                toShowMessage: false,
                isSuccess: false,
                error: "",
                successMessage: ``
            };
        default:
            return state;
    }
}

export default targetInsertStatusPayload;